import { ACTION_ERROR } from 'src/modules/assistant/constants/actions';
import { CHANNEL_BLOCK_REASON } from 'src/modules/conversations/channels';
import { CONVERSATIONS_API_ERROR } from 'src/modules/conversations/api';

const CHANNEL_SEND_ERRORS: Readonly<Record<string, string>> = Object.freeze({
    [CONVERSATIONS_API_ERROR.SESSION_MESSAGE_REQUIRES_INBOUND]:
        CHANNEL_BLOCK_REASON.NO_CONVERSATION,
    [CONVERSATIONS_API_ERROR.NO_ACTIVE_CONVERSATION_CHANNEL]:
        CHANNEL_BLOCK_REASON.CHANNEL_INACTIVE,
    [CONVERSATIONS_API_ERROR.TOKEN_EXPIRED]:
        CHANNEL_BLOCK_REASON.CHANNEL_INACTIVE,
});

/**
 * Action error for a failed `WarboxConversation` send: the channel block reason
 * the draft already explains, or a generic execution failure.
 */
export const toChannelSendError = (error: unknown): string =>
    CHANNEL_SEND_ERRORS[(error as Error)?.message] ||
    ACTION_ERROR.EXECUTION_FAILED;
